'use client';

import styled from '@emotion/styled';
import { Tab, TabProps, Tabs } from '@mui/material';
import type { LinkProps } from 'next/link';

export const StyledTabs = styled(Tabs)`
  & .MuiTabScrollButton-root.Mui-disabled {
    display: none;
  }

  & .MuiTabs-flexContainer {
    justify-content: space-around;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    & .MuiTabs-flexContainer {
      justify-content: flex-start;
    }
  }
`;

export const StyledTab = styled(Tab)<TabProps & LinkProps>`
  font-size: 12px;
  min-height: 56px;
  color: ${({ theme }) => theme.vars.palette.neutral[20]};

  & .MuiTab-iconWrapper {
    width: 24px;
    height: 24px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 18px;
    color: ${({ theme }) => theme.vars.palette.text.primary};
    & .MuiTab-iconWrapper {
      display: none;
    }
  }
`;
